"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Versoes = void 0;
var bson_1 = require("bson");
var IVisibilidade_1 = require("../../enums/IVisibilidade");
var TabelasVersao_1 = require("./TabelasVersao");
var Versoes = /** @class */ (function () {
    function Versoes(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.nome, nome = _c === void 0 ? '' : _c, _d = _a.login, login = _d === void 0 ? '' : _d, _e = _a.sequencial, sequencial = _e === void 0 ? 0 : _e, _f = _a.visibilidade, visibilidade = _f === void 0 ? IVisibilidade_1.IVisibilidade.publico : _f, _g = _a.nomeTabelas, nomeTabelas = _g === void 0 ? new TabelasVersao_1.TabelasVersao() : _g;
        this._id = _id;
        this.nome = nome;
        this.login = login;
        this.sequencial = sequencial;
        this.visibilidade = visibilidade;
        this.nomeTabelas = nomeTabelas;
    }
    return Versoes;
}());
exports.Versoes = Versoes;
//# sourceMappingURL=Versoes.js.map